import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c199ae1e")

_pushScopeId("data-v-c199ae1e")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c flex--gap-50" }
const _hoisted_2 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_3 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
const _hoisted_4 = { class: "flex flex--width flex--v flex--gap-30" }
const _hoisted_5 = { class: "text text--primary-b text--size-27 text--medium text--height-22 text--left" }
const _hoisted_6 = { class: "flex flex--width flex--v" }
const _hoisted_7 = {
  for: "name",
  class: "form-label"
}
const _hoisted_8 = {
  id: "nameHelp",
  class: "form-text"
}
const _hoisted_9 = { class: "flex flex--width flex--v" }
const _hoisted_10 = {
  for: "description",
  class: "form-label"
}
const _hoisted_11 = {
  id: "descriptionHelp",
  class: "form-text"
}
const _hoisted_12 = { class: "flex flex--width flex--v" }
const _hoisted_13 = {
  for: "email",
  class: "form-label"
}
const _hoisted_14 = {
  id: "emailHelp",
  class: "form-text"
}
const _hoisted_15 = { class: "flex flex--width flex--v" }
const _hoisted_16 = {
  for: "phone",
  class: "form-label"
}
const _hoisted_17 = {
  id: "phoneHelp",
  class: "form-text"
}
const _hoisted_18 = { class: "flex flex--width flex--v" }
const _hoisted_19 = {
  for: "website",
  class: "form-label"
}
const _hoisted_20 = {
  id: "websiteHelp",
  class: "form-text"
}
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = {
  for: "streetName",
  class: "form-label"
}
const _hoisted_24 = { class: "col-lg-2" }
const _hoisted_25 = {
  for: "streetNumber",
  class: "form-label"
}
const _hoisted_26 = { class: "row mb-3" }
const _hoisted_27 = { class: "col-lg-9" }
const _hoisted_28 = {
  for: "city",
  class: "form-label"
}
const _hoisted_29 = { class: "col-lg-3" }
const _hoisted_30 = {
  for: "zipcode",
  class: "form-label"
}
const _hoisted_31 = { class: "flex flex--width flex--v flex--gap-30" }
const _hoisted_32 = { class: "text text--primary-b text--size-27 text--medium text--height-22 text--left" }
const _hoisted_33 = { class: "flex flex--width flex--v" }
const _hoisted_34 = {
  for: "occupation",
  class: "form-label"
}
const _hoisted_35 = {
  id: "occupationHelp",
  class: "form-text"
}
const _hoisted_36 = { class: "flex flex--width flex--v" }
const _hoisted_37 = { class: "form-label" }
const _hoisted_38 = { class: "text text--size-14 text--medium" }
const _hoisted_39 = { class: "flex flex--width flex--v flex--gap-30" }
const _hoisted_40 = { class: "text text--primary-b text--size-27 text--medium text--height-22 text--left" }
const _hoisted_41 = { class: "flex flex--width flex--v" }
const _hoisted_42 = {
  for: "educational_requirements",
  class: "form-label"
}
const _hoisted_43 = {
  id: "educationalRequirementsHelp",
  class: "form-text"
}
const _hoisted_44 = { class: "flex flex--width flex--v" }
const _hoisted_45 = { class: "form-label" }
const _hoisted_46 = { class: "flex flex--v flex--gap-10" }
const _hoisted_47 = { class: "text text--size-14 text--medium" }
const _hoisted_48 = { class: "text text--size-14 text--medium" }
const _hoisted_49 = { class: "flex flex--width flex--v flex--gap-30" }
const _hoisted_50 = { class: "text text--primary-b text--size-27 text--medium text--height-22 text--left" }
const _hoisted_51 = { class: "flex flex--width flex--v" }
const _hoisted_52 = {
  for: "contact",
  class: "form-label"
}
const _hoisted_53 = {
  id: "contactHelp",
  class: "form-text"
}
const _hoisted_54 = { class: "flex flex--width flex--v flex--gap-10" }
const _hoisted_55 = { class: "flex flex--width flex--v" }
const _hoisted_56 = {
  for: "imageContactUpload",
  class: "form-label"
}
const _hoisted_57 = {
  key: 0,
  id: "imageContactHelp",
  class: "form-text"
}
const _hoisted_58 = { class: "flex flex--width flex--halign-s" }
const _hoisted_59 = {
  key: 0,
  class: "text text--color-red",
  role: "alert"
}
const _hoisted_60 = {
  key: 0,
  class: "flex flex--width flex--v flex--valign-c flex--gap-10"
}
const _hoisted_61 = { class: "company-image" }
const _hoisted_62 = { class: "flex flex--width flex--v" }
const _hoisted_63 = {
  for: "internshipTime",
  class: "form-label"
}
const _hoisted_64 = {
  id: "internshipTimeHelp",
  class: "form-text"
}
const _hoisted_65 = { class: "flex flex--width flex--v" }
const _hoisted_66 = {
  for: "internshipScope",
  class: "form-label"
}
const _hoisted_67 = {
  id: "internshipScopeHelp",
  class: "form-text"
}
const _hoisted_68 = { class: "flex flex--width flex--v flex--gap-30" }
const _hoisted_69 = { class: "text text--primary-b text--size-27 text--medium text--height-22 text--left" }
const _hoisted_70 = { class: "flex flex--width flex--v" }
const _hoisted_71 = {
  for: "internshipExtras",
  class: "form-label"
}
const _hoisted_72 = {
  id: "internshipExtrasHelp",
  class: "form-text"
}
const _hoisted_73 = { class: "flex flex--width flex--v flex--gap-10" }
const _hoisted_74 = { class: "flex flex--width flex--v" }
const _hoisted_75 = {
  for: "imageUpload",
  class: "form-label"
}
const _hoisted_76 = {
  key: 0,
  id: "imageHelp",
  class: "form-text"
}
const _hoisted_77 = { class: "flex flex--width flex--halign-s" }
const _hoisted_78 = {
  key: 0,
  class: "text text--color-red",
  role: "alert"
}
const _hoisted_79 = {
  key: 0,
  class: "flex flex--width flex--v flex--valign-c flex--gap-10"
}
const _hoisted_80 = { class: "company-image" }
const _hoisted_81 = {
  key: 0,
  class: "flex flex--v flex--valign-s flex--gap-15",
  role: "alert"
}
const _hoisted_82 = { class: "text text--color-red text--size-18 text--semi-bold text--center" }
const _hoisted_83 = { class: "text text--accent-gray-b text--size-18 text--semi-bold text--center" }
const _hoisted_84 = { class: "flex flex--width flex--v flex--valign-c flex--gap-30" }
const _hoisted_85 = {
  key: 0,
  class: "full-width mb-3 form-check"
}
const _hoisted_86 = {
  class: "form-check-label",
  for: "active"
}
const _hoisted_87 = {
  id: "activeHelp",
  class: "form-text"
}
const _hoisted_88 = { class: "bottom-buttons flex flex--v flex--halign-c flex--valign-c flex--gap-20" }
const _hoisted_89 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_90 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
const _hoisted_91 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_92 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
const _hoisted_93 = {
  key: 2,
  class: "bottom-buttons flex flex--v flex--halign-c flex--valign-c flex--gap-20"
}
const _hoisted_94 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_95 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
const _hoisted_96 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_97 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_Plane = _resolveComponent("Plane")
  const _component_FindCompanyEconomicSectorOptions = _resolveComponent("FindCompanyEconomicSectorOptions")
  const _component_FindCompanySkills = _resolveComponent("FindCompanySkills")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('company.button_submit', _ctx.submitButtonChoice),
        disabled: _ctx.processing || !_ctx.formCompany.name,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(false)))
      }, null, 8, ["title", "disabled"]),
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('company.button_submit_and_continue', _ctx.submitButtonChoice),
        disabled: _ctx.processing || !_ctx.formCompany.name,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(true)))
      }, null, 8, ["title", "disabled"]),
      (!_ctx.create)
        ? (_openBlock(), _createBlock(_component_GenericButton, {
            key: 0,
            class: "btn-group-button",
            title: _ctx.$transChoice('company.button_submit', 3),
            secondary: true,
            disabled: _ctx.processing || !_ctx.formCompany.name,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit(false, true)))
          }, null, 8, ["title", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('company.button_submit', _ctx.submitButtonChoice),
        disabled: _ctx.processing || !_ctx.formCompany.name,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit(false)))
      }, null, 8, ["title", "disabled"]),
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('company.button_submit_and_continue', _ctx.submitButtonChoice),
        disabled: _ctx.processing || !_ctx.formCompany.name,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit(true)))
      }, null, 8, ["title", "disabled"]),
      (!_ctx.create)
        ? (_openBlock(), _createBlock(_component_GenericButton, {
            key: 0,
            class: "btn-group-button",
            title: _ctx.$transChoice('company.button_submit', 3),
            secondary: true,
            disabled: _ctx.processing || !_ctx.formCompany.name,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submit(false, true)))
          }, null, 8, ["title", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Plane, {
      darker: true,
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$trans("acp.company_create_1")), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$trans("company.name") + "*"), 1),
            _withDirectives(_createVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formCompany.name = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "nameHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.name]
            ]),
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$trans("company.name_help")), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$trans("company.description")), 1),
            _withDirectives(_createVNode("textarea", {
              id: "description",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formCompany.description = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "descriptionHelp",
              rows: "5",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.description]
            ]),
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$trans("company.description_help")), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$trans("company.email")), 1),
            _withDirectives(_createVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formCompany.email = $event)),
              type: "email",
              class: "form-control",
              "aria-describedby": "emailHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.email]
            ]),
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$trans("company.email_help")), 1)
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$trans("company.phone")), 1),
            _withDirectives(_createVNode("input", {
              id: "phone",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formCompany.phone = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "phoneHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.phone]
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$trans("company.phone_help")), 1)
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$trans("company.website")), 1),
            _withDirectives(_createVNode("input", {
              id: "website",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formCompany.website = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "websiteHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.website]
            ]),
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$trans("company.website_help")), 1)
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$trans("company.streetName")), 1),
              _withDirectives(_createVNode("input", {
                id: "streetName",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formCompany.street_name = $event)),
                type: "text",
                class: "form-control",
                readonly: _ctx.readonly
              }, null, 8, ["readonly"]), [
                [_vModelText, _ctx.formCompany.street_name]
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$trans("company.streetNumber")), 1),
              _withDirectives(_createVNode("input", {
                id: "streetNumber",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formCompany.street_number = $event)),
                type: "number",
                class: "form-control",
                readonly: _ctx.readonly
              }, null, 8, ["readonly"]), [
                [_vModelText, _ctx.formCompany.street_number]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$trans("company.city")), 1),
              _withDirectives(_createVNode("input", {
                id: "city",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formCompany.city = $event)),
                type: "text",
                class: "form-control",
                readonly: _ctx.readonly
              }, null, 8, ["readonly"]), [
                [_vModelText, _ctx.formCompany.city]
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$trans("company.zipcode")), 1),
              _withDirectives(_createVNode("input", {
                id: "zipcode",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formCompany.zipcode = $event)),
                type: "number",
                class: "form-control",
                readonly: _ctx.readonly
              }, null, 8, ["readonly"]), [
                [_vModelText, _ctx.formCompany.zipcode]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Plane, {
      darker: true,
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_31, [
          _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$trans("acp.company_create_2")), 1),
          _createVNode("div", _hoisted_33, [
            _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$trans("company.occupation")), 1),
            _withDirectives(_createVNode("input", {
              id: "occupation",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formCompany.occupation = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "occupationHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.occupation]
            ]),
            _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$trans("company.occupation_help")), 1)
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$trans("company.economic_sectors")), 1),
            _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$trans("company.economic_sectors_help")), 1)
          ]),
          _createVNode(_component_FindCompanyEconomicSectorOptions, {
            sectors: _ctx.economicSectors,
            "selected-sectors": _ctx.formCompanySectorIds,
            onSectorValueChanged: _ctx.handleSectorsChanged
          }, null, 8, ["sectors", "selected-sectors", "onSectorValueChanged"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Plane, {
      darker: true,
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_39, [
          _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$trans("acp.company_create_3")), 1),
          _createVNode("div", _hoisted_41, [
            _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$trans("company.educational_requirements")), 1),
            _withDirectives(_createVNode("input", {
              id: "educational_requirements",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formCompany.educational_requirements = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "educationalRequirementsHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.educational_requirements]
            ]),
            _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$trans("company.educational_requirements_help")), 1)
          ]),
          _createVNode("div", _hoisted_44, [
            _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$trans("company.qualification_title")), 1),
            _createVNode("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, _toDisplayString(_ctx.$trans("company.qualification_help")), 1),
              _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$trans("company.qualification_specific")), 1)
            ])
          ]),
          _createVNode(_component_FindCompanySkills, {
            "qualification-groups": _ctx.qualificationGroups,
            "company-requirements": _ctx.formCompany.requirements,
            create: true,
            onCreateValueChanged: _ctx.handleQualificationValueChangedEvent
          }, null, 8, ["qualification-groups", "company-requirements", "onCreateValueChanged"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Plane, {
      darker: true,
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_49, [
          _createVNode("span", _hoisted_50, _toDisplayString(_ctx.$trans("acp.company_create_4")), 1),
          _createVNode("div", _hoisted_51, [
            _createVNode("label", _hoisted_52, _toDisplayString(_ctx.$trans("company.contact")), 1),
            _withDirectives(_createVNode("input", {
              id: "contact",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formCompany.contact = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "contactHelp",
              readonly: _ctx.readonly
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.contact]
            ]),
            _createVNode("div", _hoisted_53, _toDisplayString(_ctx.$trans("company.contact_help")), 1)
          ]),
          _createVNode("div", _hoisted_54, [
            _createVNode("div", _hoisted_55, [
              _createVNode("label", _hoisted_56, _toDisplayString(_ctx.$trans("company.image_contact", {
                                    args: { imageSize: _ctx.imageSize },
                                })), 1),
              _createVNode("input", {
                id: "imageContactUpload",
                class: "form-control",
                type: "file",
                accept: ".jpeg,.png,.jpg,.gif,.bmp,.webp",
                disabled: _ctx.formCompany.id === undefined,
                "aria-describedby": "imageContactHelp",
                readonly: _ctx.readonly,
                onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onChangeImageContactInput && _ctx.onChangeImageContactInput(...args)))
              }, null, 40, ["disabled", "readonly"]),
              (_ctx.formCompany.id === undefined)
                ? (_openBlock(), _createBlock("div", _hoisted_57, _toDisplayString(_ctx.$trans("company.image_contact_disabled")), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_58, [
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('company.upload'),
                circular: true,
                disabled: !_ctx.imageContactInput || !_ctx.formCompany.id,
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.imageUpload(true)))
              }, null, 8, ["title", "disabled"])
            ]),
            (_ctx.imageErrors.contact.length > 0)
              ? (_openBlock(), _createBlock("ul", _hoisted_59, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageErrors.contact, (error, index) => {
                    return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.formCompany.image_contact)
            ? (_openBlock(), _createBlock("div", _hoisted_60, [
                _createVNode("div", _hoisted_61, [
                  _createVNode("img", {
                    src: _ctx.formCompany.image_contact.imageUrl,
                    class: "img-fluid"
                  }, null, 8, ["src"])
                ]),
                _createVNode(_component_GenericButton, {
                  title: _ctx.$trans('company.image_delete'),
                  circular: true,
                  secondary: true,
                  disabled: _ctx.readonly,
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.imageDelete(true)))
                }, null, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_62, [
            _createVNode("label", _hoisted_63, _toDisplayString(_ctx.$trans("company.internship_time")), 1),
            _withDirectives(_createVNode("input", {
              id: "internshipTime",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.formCompany.internship_time = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "internshipTimeHelp",
              readonly: _ctx.readonly,
              maxlength: "100"
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.internship_time]
            ]),
            _createVNode("div", _hoisted_64, _toDisplayString(_ctx.$trans("company.internship_time_help")), 1)
          ]),
          _createVNode("div", _hoisted_65, [
            _createVNode("label", _hoisted_66, _toDisplayString(_ctx.$trans("company.internship_scope")), 1),
            _withDirectives(_createVNode("input", {
              id: "internshipScope",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.formCompany.internship_scope = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "internshipScopeHelp",
              readonly: _ctx.readonly,
              maxlength: "250"
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.internship_scope]
            ]),
            _createVNode("div", _hoisted_67, _toDisplayString(_ctx.$trans("company.internship_scope_help")), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Plane, {
      darker: true,
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_68, [
          _createVNode("span", _hoisted_69, _toDisplayString(_ctx.$trans("acp.company_create_5")), 1),
          _createVNode("div", _hoisted_70, [
            _createVNode("label", _hoisted_71, _toDisplayString(_ctx.$trans("company.internship_extras")), 1),
            _withDirectives(_createVNode("input", {
              id: "internshipExtras",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.formCompany.internship_extras = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "internshipExtrasHelp",
              readonly: _ctx.readonly,
              maxlength: "2000"
            }, null, 8, ["readonly"]), [
              [_vModelText, _ctx.formCompany.internship_extras]
            ]),
            _createVNode("div", _hoisted_72, _toDisplayString(_ctx.$trans("company.internship_extras_help")), 1)
          ]),
          _createVNode("div", _hoisted_73, [
            _createVNode("div", _hoisted_74, [
              _createVNode("label", _hoisted_75, _toDisplayString(_ctx.$trans("company.image", { args: { imageSize: _ctx.imageSize } })), 1),
              _createVNode("input", {
                id: "imageUpload",
                class: "form-control",
                type: "file",
                accept: ".jpeg,.png,.jpg,.gif,.bmp,.webp",
                disabled: _ctx.formCompany.id === undefined,
                "aria-describedby": "imageHelp",
                readonly: _ctx.readonly,
                onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onChangeImageInput && _ctx.onChangeImageInput(...args)))
              }, null, 40, ["disabled", "readonly"]),
              (_ctx.formCompany.id === undefined)
                ? (_openBlock(), _createBlock("div", _hoisted_76, _toDisplayString(_ctx.$trans("company.image_disabled")), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_77, [
              _createVNode(_component_GenericButton, {
                title: _ctx.$trans('company.upload'),
                circular: true,
                disabled: !_ctx.imageInput || !_ctx.formCompany.id,
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.imageUpload(false)))
              }, null, 8, ["title", "disabled"])
            ]),
            (_ctx.imageErrors.logo.length > 0)
              ? (_openBlock(), _createBlock("ul", _hoisted_78, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageErrors.logo, (error, index) => {
                    return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.formCompany.image)
            ? (_openBlock(), _createBlock("div", _hoisted_79, [
                _createVNode("div", _hoisted_80, [
                  _createVNode("img", {
                    src: _ctx.formCompany.image.imageUrl,
                    class: "img-fluid"
                  }, null, 8, ["src"])
                ]),
                _createVNode(_component_GenericButton, {
                  title: _ctx.$trans('company.image_delete'),
                  circular: true,
                  secondary: true,
                  disabled: _ctx.readonly,
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.imageDelete(false)))
                }, null, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.submitErrors.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_81, [
          _createVNode("div", _hoisted_82, _toDisplayString(_ctx.$trans("company.error_title")), 1),
          _createVNode("ul", _hoisted_83, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.submitErrors, (error, index) => {
              return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showActiveCheckbox)
      ? (_openBlock(), _createBlock(_component_Plane, {
          key: 1,
          darker: true,
          rounded: true
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_84, [
              (_ctx.showActiveCheckbox)
                ? (_openBlock(), _createBlock("div", _hoisted_85, [
                    _createVNode("input", {
                      id: "active",
                      checked: _ctx.formCompany.active === 1,
                      type: "checkbox",
                      class: "form-check-input",
                      "aria-describedby": "activeHelp",
                      disabled: !!_ctx.policies && !_ctx.policies.COMPANY_ACTIVE,
                      onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.formCompany.active = _ctx.formCompany.active === 1 ? 0 : 1))
                    }, null, 40, ["checked", "disabled"]),
                    _createVNode("label", _hoisted_86, _toDisplayString(_ctx.$trans("company.active")), 1),
                    _createVNode("div", _hoisted_87, _toDisplayString(!!_ctx.policies && !_ctx.policies.COMPANY_ACTIVE ? _ctx.$trans("company.active_help_customer") : _ctx.$trans("company.active_help")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_88, [
                _createVNode("div", _hoisted_89, [
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$transChoice('company.button_submit', _ctx.submitButtonChoice),
                    disabled: _ctx.processing || !_ctx.formCompany.name,
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.submit(false)))
                  }, null, 8, ["title", "disabled"]),
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$transChoice('company.button_submit_and_continue', _ctx.submitButtonChoice),
                    disabled: _ctx.processing || !_ctx.formCompany.name,
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submit(true)))
                  }, null, 8, ["title", "disabled"]),
                  (!_ctx.create)
                    ? (_openBlock(), _createBlock(_component_GenericButton, {
                        key: 0,
                        class: "btn-group-button",
                        title: _ctx.$transChoice('company.button_submit', 3),
                        secondary: true,
                        disabled: _ctx.processing || !_ctx.formCompany.name,
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.submit(false, true)))
                      }, null, 8, ["title", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_90, [
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$transChoice('company.button_submit', _ctx.submitButtonChoice),
                    disabled: _ctx.processing || !_ctx.formCompany.name,
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.submit(false)))
                  }, null, 8, ["title", "disabled"]),
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$transChoice('company.button_submit_and_continue', _ctx.submitButtonChoice),
                    disabled: _ctx.processing || !_ctx.formCompany.name,
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submit(true)))
                  }, null, 8, ["title", "disabled"]),
                  (!_ctx.create)
                    ? (_openBlock(), _createBlock(_component_GenericButton, {
                        key: 0,
                        class: "btn-group-button",
                        title: _ctx.$transChoice('company.button_submit', 3),
                        secondary: true,
                        disabled: _ctx.processing || !_ctx.formCompany.name,
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.submit(false, true)))
                      }, null, 8, ["title", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_91, [
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$trans('company.button_reset'),
                    simple: true,
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.clickInertiaLink('companies.create')))
                  }, null, 8, ["title"]),
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$trans('company.button_cancel'),
                    danger: true,
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.clickInertiaLink('companies.index')))
                  }, null, 8, ["title"])
                ]),
                _createVNode("div", _hoisted_92, [
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$trans('company.button_reset'),
                    simple: true,
                    onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.clickInertiaLink('companies.create')))
                  }, null, 8, ["title"]),
                  _createVNode(_component_GenericButton, {
                    class: "btn-group-button",
                    title: _ctx.$trans('company.button_cancel'),
                    danger: true,
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.clickInertiaLink('companies.index')))
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock("div", _hoisted_93, [
          _createVNode("div", _hoisted_94, [
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$transChoice('company.button_submit', _ctx.submitButtonChoice),
              disabled: _ctx.processing || !_ctx.formCompany.name,
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.submit(false)))
            }, null, 8, ["title", "disabled"]),
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$transChoice('company.button_submit_and_continue', _ctx.submitButtonChoice),
              disabled: _ctx.processing || !_ctx.formCompany.name,
              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.submit(true)))
            }, null, 8, ["title", "disabled"]),
            (!_ctx.create)
              ? (_openBlock(), _createBlock(_component_GenericButton, {
                  key: 0,
                  class: "btn-group-button",
                  title: _ctx.$transChoice('company.button_submit', 3),
                  secondary: true,
                  disabled: _ctx.processing || !_ctx.formCompany.name,
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.submit(false, true)))
                }, null, 8, ["title", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_95, [
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$transChoice('company.button_submit', _ctx.submitButtonChoice),
              disabled: _ctx.processing || !_ctx.formCompany.name,
              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.submit(false)))
            }, null, 8, ["title", "disabled"]),
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$transChoice('company.button_submit_and_continue', _ctx.submitButtonChoice),
              disabled: _ctx.processing || !_ctx.formCompany.name,
              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.submit(true)))
            }, null, 8, ["title", "disabled"]),
            (!_ctx.create)
              ? (_openBlock(), _createBlock(_component_GenericButton, {
                  key: 0,
                  class: "btn-group-button",
                  title: _ctx.$transChoice('company.button_submit', 3),
                  secondary: true,
                  disabled: _ctx.processing || !_ctx.formCompany.name,
                  onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.submit(false, true)))
                }, null, 8, ["title", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_96, [
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$trans('company.button_reset'),
              simple: true,
              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.clickInertiaLink('companies.create')))
            }, null, 8, ["title"]),
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$trans('company.button_cancel'),
              danger: true,
              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.clickInertiaLink('companies.index')))
            }, null, 8, ["title"])
          ]),
          _createVNode("div", _hoisted_97, [
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$trans('company.button_reset'),
              simple: true,
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.clickInertiaLink('companies.create')))
            }, null, 8, ["title"]),
            _createVNode(_component_GenericButton, {
              class: "btn-group-button",
              title: _ctx.$trans('company.button_cancel'),
              danger: true,
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.clickInertiaLink('companies.index')))
            }, null, 8, ["title"])
          ])
        ]))
  ]))
})